import { FC } from 'react';

import { SECTIONS_IDS } from '../../../constants/sections';
import { Box } from '../common/Box';
import { Container } from '../common/Container';
import { Flex } from '../common/Flex';
import { Link } from '../common/Link';
import { Text } from '../common/Text';
import { solutionPages } from '../SolutionPage/solutionPagesData';

import styles from './BusinessModelsBlock.module.scss';

export const BusinessModelsBlock: FC = () => {
  return (
    <Container id={SECTIONS_IDS.solutions}>
      <Flex direction={'column'} gap={4} className={styles.root}>
        <Flex direction={'column'} gap={4}>
          <Text type={'h2'}>Built for modern business models</Text>

          <Text type={'body16'} color={'white50'}>
            Whether you’re a merchant, marketplace, or financial institution — tailor payments to your needs
          </Text>
        </Flex>

        <div className={styles.grid}>
          {solutionPages.map(({ slug, card: { title, description, Icon } }) => (
            <Link
              key={slug}
              href={`/solutions/${slug}`}
              className={styles.cardLink}
              aria-label={`${title}: open solution`}
            >
              <Box
                icon={<Icon />}
                iconSize="40px"
                title={title}
                description={description}
                className={styles.cardStretch}
              />
            </Link>
          ))}
        </div>
      </Flex>
    </Container>
  );
};
